import AuthForm from '../components/Auth/AuthForm';

const AuthPage = () => <AuthForm />;

export default AuthPage;
